<script setup lang="ts">
    import { useRoute } from 'vue-router';

    type Props = {
        heading?: string;
        icon?: string;
        linkTo?: string;
        linkLabel?: string;
    };

    const props = withDefaults(defineProps<Props>(), {
        heading: 'Not Found',
        icon: 'map-marker-question',
        linkTo: '/',
        linkLabel: 'Go to the front page'
    });

    const route = useRoute();
</script>

<template>
    <section class="center-large-text section">
        <b-icon
            size="is-large"
            :icon="props.icon"
            class="mb-5" />
        <h1
            class="title">
            {{ props.heading }}
        </h1>
        <p>
            <slot>
                The page <strong>{{ route.fullPath }}</strong> could not be found
            </slot>
        </p>
        <br>
        <router-link :to="props.linkTo">
            {{ props.linkLabel }}
        </router-link>
    </section>
</template>
